module.exports = __webpack_public_path__ + "media/images/version_merge/raffle_promotion-success-aa4265391dc1db6edd260755a2867dd1.jpg";